import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { customizeHorizontalScrollbarThumbMixin } from 'styles/mixins'

export const ImagesGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: scroll;
  ${customizeHorizontalScrollbarThumbMixin()}
  padding: 8px 0;
`

export const ImageOuterContainer = styled.div`
  overflow: visible;
  position: relative;
  width: 108px;
  height: 108px;
  flex-shrink: 0;

  .loading-spinner {
    position: absolute;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const Image = styled.img<{ $isLoading?: boolean }>`
  object-fit: cover;
  max-width: 100%;
  max-height: 100%;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.5s ease-in-out;
`

export const RemoveButton = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondarySemiLight};
  }

  transition: all 0.2s ease-in-out;

  &:hover {
    svg {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`

const activeAddStyles = css`
  background-color: ${COLORS.primaryLight};
  border-style: solid;

  path {
    fill: ${COLORS.secondarySemiDark};
  }
`

export const AddButton = styled.div<{ $isToggled?: boolean }>`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  background-color: ${COLORS.primaryExtraLight};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  & > svg {
    width: 23px;
    height: 23px;
  }
  path {
    fill: ${COLORS.secondary};
  }

  &:hover {
    ${activeAddStyles}
  }

  ${({ $isToggled }) => $isToggled && activeAddStyles}
`

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  background-color: ${COLORS.primaryExtraLight};
`
